import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { GetAdsInfoData, GetUsersData, GetAdByIdData, GetEditAdByIdData } from "../../../lib/data";
import EditAdsUi from "../../../ui/adsUi/EditAdsUi";
import i18n from "../../../lib/i18n";
import { ThreeDot } from "react-loading-indicators";
import { typeOfcurrencyAddAds } from "../../../lib/definitions";

export default function EditAds() {
    const { adId } = useParams();
    const [adsInfoData, setAdsInfoData] = useState(null);
    const [userData, setUserData] = useState([]);
    const [adData, setAdData] = useState(null);
    const [loading, setLoading] = useState(true);
    const t = i18n.t.bind(i18n);

    useEffect(() => {
        handleApi();
    }, [adId]);

    const handleApi = async () => {
        setLoading(true);
        const infoData = await GetAdsInfoData();
        const usersData = await GetUsersData();
        const existingAdData = await GetEditAdByIdData(adId);
        
        setUserData(usersData.data);
        setAdsInfoData(infoData);
        setAdData(existingAdData);
        setLoading(false);
    };

    const search = async (param) => {
        const params = [ {"name": param} ];
        if(param){
            const usersDataFilter = await GetUsersData(1,params);
            setUserData([]);
            usersDataFilter.data.map((e) => setUserData((prev) => [...prev, e]));
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-[25rem]">
                <ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" />
            </div>
        );
    }

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">
                    {t("add_page_title.ad_edit", "Edit Ad")}
                </h1>
                <EditAdsUi typeOfcurrency={typeOfcurrencyAddAds} adData={adData} adId={adId} userData={userData} adsInfoData={adsInfoData} search={search} />
            </div>
        </div>
    );
}
